import React from 'react';
import CombinedHero from './CombinedHero';
import CTASection from './CTASection';
import styles from './styles.module.css';
import PracticeAreas from "./PracticeAreas";

function HomePage() {
  return (
    <div className={styles.homePage}>
      <CombinedHero />
      <PracticeAreas />
      <CTASection />
    </div>
  );
}

export default HomePage;
